<script lang="ts">
    import {Component, mixins, Prop, toNative} from 'vue-facing-decorator'
    import BookingPageBase from '~src/components/parts/bookingPageBase.src'
    import {CarsStoreMixin} from '@/mixins/CarsStoreMixin.vue'
    import {clone} from '@/utils/helpers'
    import {callComponentMethod} from '~/utils/vue-class-helpers'

    @Component({mixins: [BookingPageBase]})
    export class CarBookingPageLayout extends mixins(CarsStoreMixin) {
        @Prop({required: true}) offer

        initTourists(rq, tourists) {
            const touristsList = callComponentMethod(this, BookingPageBase, 'initTourists', rq, tourists)
            touristsList[0].age = rq.driverAge
            return touristsList
        }

        setTourists() {
            persistentStore.SET_TOURISTS(
                this.initTourists({...this.searchRequest, adults: 1, childrenAges: []}, clone(persistentStore.tourists))
            )
        }

        prepareBookRequest(specifiedTouristBookingFields, includeOptionalTourists = false) {
            const prepareBookRequest = callComponentMethod(
                this,
                BookingPageBase,
                'prepareBookRequest',
                specifiedTouristBookingFields,
                includeOptionalTourists
            )
            const driver = this.prepareBookTourists(
                this.tourists,
                specifiedTouristBookingFields,
                includeOptionalTourists
            )[0]
            driver.phoneNumber = driver.phone
            delete driver.phone
            delete prepareBookRequest.tourists
            prepareBookRequest.driver = driver
            prepareBookRequest.pickUpPoint = carsRentStore.pickUpLocation.locationCode
            prepareBookRequest.dropOffPoint = carsRentStore.dropOffLocation.locationCode
            return prepareBookRequest
        }

        get productSearchPageName() {
            return 'carsRent'
        }

        get productConfirmationPageName() {
            return 'carConfirmation'
        }

        get productName() {
            return 'car'
        }

        get productBookingPageName() {
            return 'carBooking'
        }

        get corporatePolicyType() {
            return 'carsRent'
        }

        get startDate() {
            return this.searchRequest.pickUpDateTime
        }
    }

    export default {...toNative(CarBookingPageLayout), ssrRender: BookingPageBase.ssrRender}
</script>
